import ContentPage from "./ContentPage";
import { ReactComponent as ChatBotFlows } from "./static/big-images/ChatBotFlows.svg";
import { ReactComponent as ChatBotStats } from "./static/big-images/ChatBotStats.svg";
import ChatBotFlowsFS from "./static/big-images/ChatBotFlowsFS.png";
import { ReactComponent as RightArrow } from "./static/icons/RightArrow.svg";
import Button from "./Button";
import Carousel from "./Carousel";
import Carousel5 from "./static/big-images/ChatBot1.png";
import Carousel6 from "./static/big-images/ChatBot2.png";
import Carousel7 from "./static/big-images/ChatBot3.png";
import Highlighter from "./Highlighter";
import AnimatedDiv from "./AnimatedDiv";
import CardsCloud from "./CardsCloud";
import { useState } from "react";
import FullScreenImage from "./FullScreenImage";

function ChatBot() {
  const [modalOpen, setModalOpen] = useState(false);
  function goFullscreen() {
    setModalOpen(true);
  }

  return (
    <>
      {modalOpen && (
        <FullScreenImage
          onClose={() => {
            console.log("closing modal");
            setModalOpen(false);
          }}
        >
          <img style={{ maxWidth: "95%" }} src={ChatBotFlowsFS}></img>
        </FullScreenImage>
      )}
      <ContentPage>
        <h2>User feedback analysis</h2>

        <h3>Role</h3>
        <p>UX Researcher | UX Writer | Product Designer </p>

        <h3>Project overview</h3>
        <p>
          Customer service automation is a huge deal, so it's something you need
          to do step by step. Our team decided to kick off this process by
          automating one of the most popular flows — account deactivation.
        </p>
        <h3>Challenge</h3>
        <p>
          Account deactivation often becomes the last straw for frustrated
          users. Since Uproad requires a prepaid balance, users want to know the
          ETA for their refund right away. Our internal research revealed that
          we were not doing good with this time-sensitive issue.
        </p>
        <AnimatedDiv className="CaseStats">
          <div className="Stat">
            <div className="BigNumber">35%</div>
            <div className="StatDescription">
              Share of users seeking support after hours
            </div>
          </div>
          <div className="Stat">
            <div className="BigNumber">14 h </div>
            <div className="StatDescription">
              14 hours our average time to first response
            </div>
          </div>
          <div className="Stat">
            <div className="BigNumber">57%</div>
            <div className="StatDescription">
              Share of users ignoring agent responses
            </div>
          </div>
        </AnimatedDiv>
        <p>
          The chatbot had to be helpful and friendly for users. Our goal was to
          provide help to the users after hours without needing to wait for the
          first response. Also, we needed to address the most common reasons for
          account cancellation.
        </p>
        <h3>Process</h3>
        <p>
          We did not have a Product Manager assigned to Customer Service
          technical improvements, so I was given full freedom to research and
          execute my chatbot ideas.
        </p>
        <p>
          First, I reviewed account deactivation chats to determine the original
          list of closure reasons. It all came to these four reasons:
        </p>
        <AnimatedDiv>
          <CardsCloud
            cardTexts={[
              "User accidentally downloaded wrong app",
              "User's road is not covered",
              "User only wanted to pay for past tolls or violations",
              "User doesn't drive much, so decides to deactivate account",
            ]}
          ></CardsCloud>
        </AnimatedDiv>
        <p>
          While reviewing our communications, I noticed that we didn't try to
          remind our users of app benefits - we just always went ahead and
          closed the account.
        </p>
        <p>
          Most of these users clearly didn't receive notifications regarding new
          chat replies, so I checked with Android and iOS developers whether we
          sent those. Turned out that due to a bug, we did not.
        </p>
        <p>
          After marking down all of these reasons as “must be covered” I moved
          onto the ideation. I came up with the idea to use our company's mascot
          as an alias for the chatbot.
        </p>
        <h3>Result</h3>
        <p>
          Prepared copy to cover the most popular account deactivation
          scenarios. Developed the chatbot flow using the Helpshift internal
          tools. The flow is quite big, so I definitely recommend opening this
          picture in full size.
        </p>
        <div
          style={{ zIndex: "9999", position: "relative" }}
          onClick={() => goFullscreen()}
        >
          <ChatBotFlows></ChatBotFlows>
        </div>
        <Button
          className="goToCaseButton"
          variant="complex"
          text="OPEN FULL SIZE IMAGE"
          onClick={() => goFullscreen()}
          icon={<RightArrow />}
        />
        <h3>Numbers</h3>
        <p>
          Key milestones after <Highlighter text="one month" /> of chatbot
          operation:
        </p>
        <AnimatedDiv>
          <ChatBotStats />
        </AnimatedDiv>
        <p>Here's a quick look at how the chatbot looks for the user:</p>
        <AnimatedDiv>
          <Carousel images={[Carousel5, Carousel6, Carousel7]} />
        </AnimatedDiv>
      </ContentPage>
    </>
  );
}
export default ChatBot;
